<template>
  <div class="your-order card">
      <h3 class="card-header text-center">Your order</h3>
      <div class="your-order-table table-responsive card-body">
        <table class="table">
          <thead>
            <tr>
              <th class="cart-product-name text-left">Product</th>
              <th class="cart-product-total">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.name" class="cart_item">
              <td class="cart-product-name"> {{ product.name }}<strong class="px-3 py-1 mx-3 badge badge-custom-primary">{{ product.qty }}</strong>
              </td>
              <td class="cart-product-total text-center"><span class="amount">{{ total(product )}} MRU</span></td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="cart-subtotal">
              <th>Cart Subtotal</th>
              <td class="text-center"><span class="amount">{{mainTotal}} MRU</span></td>
            </tr>
            <tr class="order-total">
              <th>Order Total</th>
              <td class="text-center"><strong><span class="amount">{{mainTotal}} MRU</span></strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="payment-method card-footer">
        <div class="payment-accordion">
          <div class="order-button-payment">
            <input value="Place order" type="submit">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "CheckoutOrders",
  data() {
    return {
      products: [
        {
          name: "Product 1",
          unitPrice: 50.50,
          qty: 1,
          total: () => this.unitPrice
        },
        {
          name: "Product 2",
          unitPrice: 80.00,
          qty: 4,
        },
      ]
    }
  },
  methods: {
    total(p) {
      return p.unitPrice * p.qty;
    },
     removeItem(name){
      this.products = this.products.filter(product => product.name !== name);
    }
  },
  computed: {
    mainTotal() {
      return this.products.reduce((sum, val)=>sum + val.unitPrice * val.qty, 0); 
    }
  }
}
</script>

<style>

</style>
